import { message } from 'antd';
import { useTranslation } from 'react-i18next';

function errorHandler(error: any): { messageKey: string; statusCode?: number } {
    let messageKey = 'errors.general';
    let statusCode: number | undefined;

    const response = error?.data || error?.response?.data;
    statusCode = error?.status || error?.response?.status;

    if (statusCode) {
        switch (statusCode) {
            case 404:
                messageKey = 'errors.resourceNotFound';
                break;
            case 422:
                messageKey = response?.message ?? 'errors.validationError';
                break;
            case 500:
                messageKey = response?.message ?? 'errors.internalServerError';
                break;
            default:
                messageKey = response?.message ?? 'errors.general';
                break;
        }
    } else if (error?.message) {
        messageKey = error.message;
    }

    return { messageKey, statusCode };
}

export type ResponseType =
    | 'applyPromoCode'
    | 'updateProfile'
    | 'updateSettings'
    | 'resendVerification'
    | 'changePassword'
    | 'applyDiscount'
    | 'removeFromCart'
    | 'prepareCheckout'
    | 'updateCart'
    | 'addToCart'
    | 'createOrder'
    | 'downloadQrCode'
    | 'getOrders'
    | 'getOrderDetail'
    | 'updateESim'
    | 'updatePayoutSettings'
    | 'connection'
    | 'topupOptions'
    | 'createTicket';

export function useCheckResponse() {
    const { t } = useTranslation();

    const checkResponse = (res: any, type?: ResponseType, item?: string) => {
        if (res?.status >= 200 && res?.status < 300) {
            message.success({
                content: t(`notification.success.${type}`),
                className: 'response-success',
            });
            return { success: true, data: res.data };
        }

        if (res && !res.status && !res.error) {
            message.success({
                content: t(`notification.success.${type}`),
                className: 'response-success',
            });
            return { success: true, data: res };
        }

        const { messageKey, statusCode } = errorHandler(res?.error || res);

        if (statusCode !== 401) {
            message.error({
                content: t(messageKey, { name: item }),
                className: 'response-error',
            });
        }

        return { success: false, data: null };
    };

    return { checkResponse, t };
}
